import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/admin/Dashboard";
import Hotspot from "@/pages/admin/Hotspot";
import Ftth from "@/pages/admin/Ftth";
import Accounts from "@/pages/admin/Accounts";
import CustomerCard from "@/pages/admin/CustomerCard";
import FtthCustomers from "@/pages/admin/FtthCustomers";
import Tickets from "@/pages/admin/Tickets";
import Infra from "@/pages/admin/Infra";
import PrintVouchers from "@/pages/admin/PrintVouchers";
import Settings from "@/pages/admin/Settings";
import Reports from "@/pages/admin/Reports";
import Backup from "@/pages/admin/Backup";
import AccountSettings from "@/pages/AccountSettings";
import Register from "@/pages/Register";
import Subscription from "@/pages/Subscription";
import Members from "@/pages/admin/Members";
import Portal from "@/pages/portal/Portal";
import PortalPrint from "@/pages/portal/PortalPrint";
import InstallGuide from "@/pages/InstallGuide";

const Loading = () => (
  <div className="grid min-h-screen place-items-center bg-background text-sm text-muted-foreground">Memuat…</div>
);

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={["mitra", "user"].includes(user.role) ? "/portal" : "/dashboard"} replace />;
  }
  return children;
}

function Root() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  // Belum login: tampilkan landing page (banner pembuka).
  if (user === false) return <Landing />;
  // Sudah login: banner tidak dimunculkan lagi, langsung ke dasbor/portal.
  return <Navigate to={["mitra", "user"].includes(user.role) ? "/portal" : "/dashboard"} replace />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user && user !== true && user.role) {
    return <Navigate to={["mitra", "user"].includes(user.role) ? "/portal" : "/dashboard"} replace />;
  }
  return <Login />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/instal" element={<InstallGuide />} />
            <Route path="/daftar" element={<Register />} />
            <Route path="/langganan" element={<Guard><Subscription /></Guard>} />
            <Route element={<Guard roles={["superadmin", "admin", "teknisi"]}><Shell /></Guard>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/hotspot" element={<Guard roles={["superadmin", "admin"]}><Hotspot /></Guard>} />
              <Route path="/ftth" element={<Ftth />} />
              <Route path="/pelanggan" element={<FtthCustomers />} />
              <Route path="/pelanggan/:id" element={<CustomerCard />} />
              <Route path="/tiket" element={<Tickets />} />
              <Route path="/infrastruktur" element={<Infra />} />
              <Route path="/mitra" element={<Guard roles={["superadmin", "admin"]}><Accounts role="mitra" /></Guard>} />
              <Route path="/pengguna" element={<Guard roles={["superadmin", "admin"]}><Accounts role="user" /></Guard>} />
              <Route path="/teknisi" element={<Guard roles={["superadmin", "admin"]}><Accounts role="teknisi" /></Guard>} />
              <Route path="/admin-akun" element={<Guard roles={["superadmin"]}><Accounts role="admin" /></Guard>} />
              <Route path="/member" element={<Guard roles={["superadmin"]}><Members /></Guard>} />
              <Route path="/laporan" element={<Guard roles={["superadmin", "admin"]}><Reports /></Guard>} />
              <Route path="/setting" element={<Guard roles={["superadmin", "admin"]}><Settings /></Guard>} />
              <Route path="/backup" element={<Guard roles={["superadmin", "admin"]}><Backup /></Guard>} />
              <Route path="/akun" element={<AccountSettings />} />
            </Route>
            <Route path="/portal" element={<Guard roles={["mitra", "user"]}><Portal /></Guard>} />
            <Route path="/portal/cetak" element={<Guard roles={["mitra", "user"]}><PortalPrint /></Guard>} />
            <Route path="/cetak-voucher" element={<Guard roles={["superadmin", "admin"]}><PrintVouchers /></Guard>} />            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors theme="system" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
